
export const GET_PAYMENTS_SUCCESS='GET_PAYMENTS_SUCCESS';
export const GET_PAYMENTS_REQUEST='GET_PAYMENTS_REQUEST';
export const GET_PAYMENTS_FAILURE='GET_PAYMENTS_FAILURE';

